/** Round to cents like Decimal quantize 0.01 */
export function money(n: number): number {
  return Math.round(n * 100) / 100;
}
